import { Button, Container, Grid2, Paper, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import DatePicker, { DateObject } from "react-multi-date-picker";
import { TrainingSchedule } from "../../model/entity/TrainingSchedule";
import { getFetcher, putFetcher } from "../../components/Fetchers";
import { notifErr, notifOk } from "../../components/Functions";
import handleAxiosError from "../../components/ErrorHandler";
import { Loading } from "../../components/Loading";
import { useNavigate } from "react-router-dom";

const DayCancellation = () => {
  const [schedule, setSchedule] = useState<TrainingSchedule | null>(null);
  const [selectedDates, setSelectedDates] = useState<string[]>([]);
  const datePickerRef = useRef<any>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getFetcher(
          `${process.env.REACT_APP_API_URL}/schedules/active`
        );
        setSchedule(response.data);
      } catch (err) {
        notifErr(handleAxiosError(err));
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (schedule && datePickerRef.current) datePickerRef.current.openCalendar();
    setSelectedDates(schedule?.canceledDays || []);
  }, [schedule]);

  const handleSelectDate = (dates: DateObject[]) => {
    if (!schedule) return;
    const updatedArr = dates.map((d) => d.format("YYYY-MM-DD"));
    setSelectedDates(updatedArr);
  };

  const handleResetDates = () => {
    setSelectedDates(schedule?.canceledDays || []);
  };

  const handleSubmit = async () => {
    if (!schedule) return;
    const updatedSchedule = {
      ...schedule,
      canceledDays: selectedDates,
    };
    setSchedule(updatedSchedule);

    try {
      await putFetcher(
        `${process.env.REACT_APP_API_URL}/schedules/${schedule.id}/canceled-days`,
        updatedSchedule
      );
      notifOk("Změny byly uloženy.");
    } catch (err) {
      notifErr(handleAxiosError(err));
    }
  };

  if (!schedule) return <Loading />;

  return (
    <Container
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: "50%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          backgroundColor: "#f8f8f8",
          borderRadius: ".5rem",
        }}
      >
        <Typography
          variant="h5"
          sx={{ marginTop: "1rem", color: "var(--gradientEnd)" }}
        >
          Zrušené dny
        </Typography>

        <Grid2 sx={{ userSelect: "none" }}>
          <DatePicker
            ref={datePickerRef}
            multiple={true}
            value={selectedDates}
            render={() => <></>}
            onChange={(d) => handleSelectDate(d)}
            onClose={() => false}
            calendarPosition="bottom-center"
            weekDays={["Ne", "Po", "Út", "St", "Čt", "Pá", "So"]}
            weekStartDayIndex={1}
            months={[
              "Leden",
              "Únor",
              "Březen",
              "Duben",
              "Květen",
              "Červen",
              "Červenec",
              "Srpen",
              "Září",
              "Říjen",
              "Listopad",
              "Prosinec",
            ]}
            headerOrder={["MONTH_YEAR", "LEFT_BUTTON", "RIGHT_BUTTON"]}
            arrow={false}
            highlightToday={false}
            className="dayCancelCalendar"
            mapDays={(d) => {
              if (selectedDates.includes(d.date.format("YYYY-MM-DD")))
                return {
                  style: {
                    backgroundColor: "var(--redNotOK)",
                    color: "white",
                  },
                  className: "canceled-day",
                };
              else
                return {
                  className: "regular-day",
                };
            }}
          />
        </Grid2>
        <Grid2
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            marginTop: "19rem",
            padding: ".2rem",
          }}
        >
          <Grid2 sx={{ padding: ".5rem" }}>
            <Button
              variant="outlined"
              className="cancelBtn"
              onClick={() => navigate(-1)}
            >
              Zpět
            </Button>
          </Grid2>
          <Grid2
            sx={{
              display: "flex",
              padding: ".5rem",
              gap: "0.5rem",
            }}
          >
            <Button
              variant="contained"
              className="deleteBtn"
              onClick={handleResetDates}
            >
              Reset
            </Button>
            <Button
              variant="contained"
              className="submitBtn"
              onClick={handleSubmit}
            >
              Uložit
            </Button>
          </Grid2>
        </Grid2>
      </Paper>
    </Container>
  );
};

export default DayCancellation;
